"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoLayoutPriority = void 0;
var AutoLayoutPriority;
(function (AutoLayoutPriority) {
    AutoLayoutPriority[AutoLayoutPriority["HighSpeed"] = 1] = "HighSpeed";
    AutoLayoutPriority[AutoLayoutPriority["Analog"] = 2] = "Analog";
    AutoLayoutPriority[AutoLayoutPriority["Power"] = 3] = "Power";
    AutoLayoutPriority[AutoLayoutPriority["MediumSpeed"] = 4] = "MediumSpeed";
    AutoLayoutPriority[AutoLayoutPriority["LowSpeed"] = 5] = "LowSpeed";
    AutoLayoutPriority[AutoLayoutPriority["GroundOrDefault"] = 6] = "GroundOrDefault";
})(AutoLayoutPriority || (exports.AutoLayoutPriority = AutoLayoutPriority = {}));
//# sourceMappingURL=auto_layout.js.map